import Alert from '@r1-frontend/ui-react/components/Alert';
import { InfoCircle } from '@r1-frontend/ui-react/components/svg/main';
import ControlElement from '@r1-frontend/ui-react/components/typography/controlElement';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';

import { useCtxSelector } from '~/src/features/tariffBuilder/hooks';

interface IProps {
    openChatHandler: () => void,
}
export const ChangePlanWebcabAlerts = ({ openChatHandler }: IProps): JSX.Element => {
    const changePlanWebcabData = useCtxSelector(state => state.changePlanWebcabData);

    if (changePlanWebcabData?.hasError && changePlanWebcabData.errorCode === 'INSUFFICIENT_MONEY') {
        return (
            <Alert Icon={InfoCircle} type={'error'}>
                <Paragraph4>
                    Недостаточно средств на&nbsp;договоре для смены тарифного плана. Пожалуйста, пополните Ваш баланс.
                </Paragraph4>
            </Alert>
        );
    }

    if (changePlanWebcabData?.hasError) {
        return (
            <Alert Icon={InfoCircle} type={'error'}>
                <Paragraph4>
                    Не&nbsp;удалось сменить тариф. Попробуйте ещё раз или напишите в <ControlElement type='large' onClick={openChatHandler}>поддержку.</ControlElement>
                </Paragraph4>
            </Alert>
        );
    }

    return (
        <Alert Icon={InfoCircle} type={'success'}>
            <Paragraph4>Теперь у&nbsp;вас новый тариф. Перезагрузите роутер, чтобы активировать новую скорость.</Paragraph4>
        </Alert>
    );
};
